// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from '../request'
const serveName = process.env.VUE_APP_SERVENAME

// 国家信息，ios码
export const getCountryInfo = () => request(`${serveName}/sys/dictRegionCode/list`, null, 'POST_JSON', null)
// 表格数据
export const getTaxTableData = (data: any) => request(`${serveName}/tax/list`, null, 'POST_JSON', data)
// 新增国家
export const addNewCountry = (data: any) => request(`${serveName}/tax/insert`, null, 'POST_JSON', data)
// 编辑国家
export const editCountry = (data: any) => request(`${serveName}/tax/update`, null, 'POST_JSON', data)
// 查询详情记录
export const getDetailRecord = (data: any) => request(`${serveName}/operationLog/query`, null, 'POST_JSON', data)
